import { render, staticRenderFns } from "./WorkoutCard.vue?vue&type=template&id=5374ff19&"
import script from "./WorkoutCard.vue?vue&type=script&lang=js&"
export * from "./WorkoutCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports